import { useState } from 'react'
import Panel from '../../ui/Panel'
import Tabs from '../../ui/Tabs'
import { browsers } from '../../content/browsers'
import { doh } from '../../content/site'
import styles from './BrowserSetup.module.css'

/** Renders **bold** spans without pulling in a markdown parser for six strings. */
function Step({ text }: { text: string }) {
    return (
        <>
            {text.split(/(\*\*[^*]+\*\*)/).map((part, i) =>
                part.startsWith('**')
                    ? <strong key={i}>{part.slice(2, -2)}</strong>
                    : <span key={i}>{part}</span>,
            )}
        </>
    )
}

export default function BrowserSetup() {
    const [active, setActive] = useState(browsers[0].id)
    const guide = browsers.find((b) => b.id === active) ?? browsers[0]

    return (
        <Panel title={doh.setup.heading}>
            <p className={styles.intro}>{doh.setup.body}</p>

            <Tabs
                items={browsers.map((b) => ({ id: b.id, label: b.label }))}
                active={active}
                onChange={setActive}
                label="Browser"
            >
                <div className={styles.body}>
                    <ol className={styles.steps}>
                        {guide.steps.map((step) => (
                            <li key={step}><Step text={step} /></li>
                        ))}
                    </ol>

                    {guide.settingsUrl && (
                        <p className={styles.hint}>
                            You can also go straight to <code>{guide.settingsUrl}</code>
                        </p>
                    )}
                    {guide.note && <p className={styles.hint}>{guide.note}</p>}

                    {guide.video && (
                        <video
                            className={styles.video}
                            src={guide.video.src}
                            poster={guide.video.poster}
                            controls
                            muted
                            loop
                            playsInline
                            /* metadata only: the walkthrough is opt-in, and these
                               used to be multi-megabyte gifs fetched on page load */
                            preload="none"
                            aria-label={`${guide.label} DNS-over-HTTPS setup walkthrough`}
                        />
                    )}
                </div>
            </Tabs>
        </Panel>
    )
}
